import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Modal, Button, Form } from "react-bootstrap";
import { ShimmerTitle } from "react-shimmer-effects";
import { sendGAEvent } from "../../utils/ga4";
import { useNavigate } from 'react-router-dom';





export default function RoughCountryDetails({ data, fitment, setdata }) {
    const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;

    const category_type = 'rough_country_cat';
    const productName = data.title;
    const availableStock = data.availability;

    // const inventoryStock = Number(data.quantity || 0);
    const inventoryStock = Number(data.tn_stock) + Number(data.nv_stock) || availableStock;
    const price = data.price;
    const totalStock = (Number(data.tn_stock) || 0) + (Number(data.nv_stock) || 0);

    const [valueCart, setValueCart] = useState(1);
    const [cartData, setCartData] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const [getLoader, setLoader] = useState(false);
    const navigate = useNavigate();


    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [comments, setComments] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');

    const [stockMessage, setStockMessage] = useState("");

    // ETA item with no stock → only 1 unit allowed
    const isEtaOnly =
        (totalStock === 0 && availableStock?.startsWith("ETA")) ||
        availableStock?.startsWith("Please allow 2-3 days to ship");

    const maxAllowedQty = totalStock > 0 ? totalStock : (isEtaOnly ? 1 : 0);

    useEffect(() => {
        if (data) {
            const price = data.price
            sendGAEvent("view_item", {
                currency: "USD",
                value: Number(price),
                items: [
                    {
                        item_id: data.sku,
                        item_name: data.title,
                        price: Number(price)
                    }
                ]
            });
        }
    }, [data]);


    // ========== KATAPULT PRICE CALCULATOR ==========
    useEffect(() => {
        // Load Katapult script + CSS only once
        if (window.katapult) return; // already loaded

        const _katapult_config = {
            api_key: "bfbd8625728e70566a904e6e1845b5920fc6a43f",
            environment: "https://www.katapult.com"
        };

        // Inject the official loader
        (function (e, t) {
            e.katapult = e.katapult || {};
            var n, i, r;
            i = false;
            n = document.createElement("script");
            n.type = "text/javascript";
            n.async = true;
            n.src = t.environment + "/plugin/js/katapult.js";
            n.onload = n.onreadystatechange = function () {
                if (!i && (!this.readyState || this.readyState === "complete")) {
                    i = true;
                    e.katapult.setConfig(t.api_key);
                }
            };
            r = document.getElementsByTagName("script")[0];
            r.parentNode.insertBefore(n, r);

            var s = document.createElement("link");
            s.setAttribute("rel", "stylesheet");
            s.setAttribute("type", "text/css");
            s.setAttribute("href", t.environment + "/plugin/css/katapult.css");
            var a = document.querySelector("head");
            a.insertBefore(s, a.firstChild);
        })(window, _katapult_config);
    }, []);

    // Update the "as low as" price whenever price changes
    useEffect(() => {
        if (!price || price <= 0) return;

        // Wait a bit for Katapult to be ready
        const timer = setTimeout(() => {
            if (window.katapult && typeof window.katapult.estimatePrice === "function") {
                // Update data attributes
                document.querySelectorAll("[data-katapult-item-price]").forEach((el) => {
                    el.setAttribute("data-katapult-item-price", price);
                });
                window.katapult.estimatePrice();
            }
        }, 500);

        return () => clearTimeout(timer);
    }, [price]);


    const apiAddtoCart = async (cartItems) => {
        setLoader(true);
        try {
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${mainUrl}/api/add-to-cart`,
                credentials: 'include',
                withCredentials: true,

                params: {
                    product_id: data.sku,
                    product_name: productName,
                    product_price: data.price,
                    product_quantity: valueCart,
                    category_type: category_type,
                    total_quantity: maxAllowedQty,
                    part_number: data.sku,
                    vendor_id: data.vendor_id,
                    product_image: data.image_1
                },
                data: {
                    cart_key: localStorage.getItem("cart-key") || '',
                    user_token: localStorage.getItem("user-token") || ''
                }
            };

            const response = await axios.request(config);

            localStorage.setItem("cart-key", response.data.addCartResponse);
            localStorage.setItem('totalCartItems', JSON.stringify(cartItems));
            setCartData(cartItems);
            setdata(cartItems);

            toast.success("Item Added to cart!", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
            setLoader(false);

        } catch (error) {
            console.error('Error fetching data:', error);
            setLoader(false);
        }
    };

    const addItemstoCaart = () => {
        const cartItems = JSON.parse(localStorage.getItem('totalCartItems')) || {};
        const itemId = data.sku;
        const existingValue = cartItems[itemId] || 0;
        const updatedValue = existingValue + valueCart;

        if (updatedValue > maxAllowedQty) {
            toast.info("Cannot add more items than available in stock!", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
            return;
        }
        cartItems[itemId] = updatedValue;

        // GA4 add_to_cart event
        sendGAEvent("add_to_cart", {
            currency: "USD",
            value: Number(data.price),
            items: [
                {
                    item_id: data.sku,
                    item_name: data.title,
                    price: Number(data.price),
                    quantity: valueCart
                }
            ]
        });

        apiAddtoCart(cartItems);
    };


    const increaseValue = () => {
        if (valueCart < inventoryStock) {
            setValueCart(valueCart + 1);
        }
    };

    const decreaseValue = () => {
        if (valueCart > 1) {
            setValueCart(valueCart - 1);
        }
    }

    // const increaseValue = () => {
    //     if (availableStock?.startsWith("ETA") || availableStock?.startsWith("Please")) {
    //         setStockMessage(
    //             "You can get only one product."
    //         );
    //         return;
    //     }
    //     setStockMessage("");
    //     if (valueCart < inventoryStock) {
    //         setValueCart(valueCart + 1);
    //     }
    // };

    // const decreaseValue = () => {
    //     setStockMessage("");
    //     if (valueCart > 1) {
    //         setValueCart(valueCart - 1);
    //     }
    // };

    const handleEnquiryModel = () => {
        setShowModal(true)
    }

    const handleClose = () => {
        setShowModal(false)
    }


    const handleFirstNameChange = (e) => {
        setFirstName(e.target.value);
    };

    const handleLastNameChange = (e) => {
        setLastName(e.target.value);
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const handlePhoneChange = (e) => {
        const cleanedInput = e.target.value.replace(/\D/g, '');
        setPhone(cleanedInput);
    };

    const handleCommentsChange = (e) => {
        setComments(e.target.value);
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        try {
            try {
                let config = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: `${mainUrl}/api/submit-inquiry`,
                    credentials: 'include',
                    withCredentials: true,
                    params: {
                        email: email,
                        phone: phone,
                        comments: comments,
                        firstName: firstName,
                        lastName: lastName

                    }
                };
                axios
                    .request(config)
                    .then((response) => {
                        toast.success("Submitted successfully!", {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        });
                        setEmail('');
                        setPhone('');
                        setComments('');
                        handleClose();

                    })
                    .catch((error) => {
                        console.log(error);

                    });
            } catch (error) {
                console.error('Error fetching data:', error);

            }

        } catch (error) {
            console.error('Error submitting inquiry:', error);
        }
    };

    const formatEtaDate = (etaString) => {
        const datePart = etaString.replace("ETA", "").trim();
        const [month, day, year] = datePart.split("/");
        const date = new Date(year, month - 1, day);
        const options = { month: "short", day: "numeric", year: "numeric" };
        return date.toLocaleDateString("en-US", options).toUpperCase();
    };


    const isPastEta = (eta) => {
        if (!eta?.startsWith("ETA")) return false;

        const dateStr = eta.replace("ETA", "").trim();
        const etaDate = new Date(dateStr);

        if (isNaN(etaDate)) return false;

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        etaDate.setHours(0, 0, 0, 0);

        return etaDate < today;
    };

    const isOutOfStock =
        availableStock?.toLowerCase() === "out of stock" ||
        isPastEta(availableStock);

    return (
        <>
            <div className="main-product-data">
                <div className="product-name-details">
                    <span className="tag_name">{data.manufacturer}</span>
                    <h2>{productName}</h2>
                    <span className="prod_cat">{data.category}</span>

                    <div className="stock mb-3">
                        {(availableStock === "In Stock" || availableStock === "Out Of Stock") && (
                            <h3 className="m-0">Stock</h3>
                        )}

                        {availableStock?.startsWith("Please") && (
                            <h3 className="m-0">
                                Special Order Item: {availableStock}
                            </h3>
                        )}


                        <h4 className="m-0">
                            {availableStock?.startsWith("ETA") && !isPastEta(availableStock) ? (
                                <div className="eta-box">
                                    <span className="eta-badge">
                                        ESTIMATED SHIP DATE: {formatEtaDate(availableStock)}
                                    </span>
                                </div>
                            ) : availableStock?.startsWith("Please") ? (
                                null
                            ) : availableStock === "In Stock" && inventoryStock > 0 ? (
                                <span className="in-stock">
                                    <i className="fa fa-circle me-1"></i> In Stock ({inventoryStock})
                                </span>
                            ) : (
                                <span className="out-stock">
                                    <i className="fa fa-circle me-1"></i> Out Of Stock
                                </span>
                            )}
                        </h4>

                        <h5 className="m-0">
                            SKU: <span>{data.sku}</span>
                        </h5>
                    </div>

                    {totalStock > 0 && (
                        <div className="stock">
                            <h3 className="m-0">TN Stock: ( {data.tn_stock} ) NV Stock: ( {data.nv_stock} )</h3>
                        </div>
                    )}

                    {/* ===== KATAPULT PRICE CALCULATOR WIDGET ===== */}
                    {price > 0 && (
                        <div className="katapult-price-calculator my-3">
                            <div className="katapult-flex">
                                <div className="katapult-price-calculator-logo"></div>
                                &nbsp;
                                <span className="katapult-price-calculator-lease">Lease to own</span>
                                &nbsp;
                                <span
                                    className="katapult-price-calculator-pay"
                                    data-katapult-item-price={price}
                                >
                                    Pay as low as
                                </span>
                                &nbsp;
                                <a
                                    href="#"
                                    className="katapult-price-calculator-price btn-katapult-price-calculator"
                                    data-katapult-item-price={price}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (window.katapult) {
                                            window.katapult.loadPriceCalculator({
                                                cash_price: price,
                                                // zip_code: "optional",   // add if you have it
                                                is_click_on_pre_approve: false,
                                            });
                                        }
                                    }}
                                >
                                    $/week
                                </a>
                            </div>
                            <div>
                                <a
                                    href="#"
                                    className="katapult-price-calculator-pre-approve btn-katapult-price-calculator"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (window.katapult) {
                                            window.katapult.loadPriceCalculator({
                                                cash_price: price,
                                                is_click_on_pre_approve: true,
                                            });
                                        }
                                    }}
                                >
                                    Apply Now! No Credit Required!
                                </a>
                            </div>
                        </div>
                    )}

                    <div className="product-deastil-preice deal_of_the_day">
                        <div className='price'>
                            <h2>
                                ${parseFloat(data.price).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                                {/* {(data.sale_price > data.price) && data.price > 0 ? <s>MSRP&nbsp;${parseFloat(data.sale_price).toFixed(2)}</s> : " "} */}
                            </h2>
                        </div>

                    </div>


                    <div className="quantity">
                        {isOutOfStock ? (
                            <>
                                <div className="cart">Out of Stock !</div>
                                <div className="Finance">
                                    <button
                                        className="Finance"
                                        title="Item out of stock"
                                        onClick={handleEnquiryModel}
                                    >
                                        Click for Enquiry
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="incres">
                                    <div className="value-button" id="decrease" onClick={decreaseValue}>
                                        <i className="fa fa-minus"></i>
                                    </div>
                                    <input type="text" id="number" aria-label="value cart" value={valueCart} disabled />
                                    <div className="value-button" id="increase" onClick={increaseValue}>
                                        <i className="fa fa-plus"></i>
                                    </div>
                                </div>

                                <div className="cart">
                                    {!getLoader ? (
                                        <button onClick={addItemstoCaart}>
                                            <svg className="me-1" width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M0.982759 1.96567H4.07847L5.65092 10.9827C5.7738 11.6214 6.48624 12.2849 7.10048 12.2849H17.6654C18.3288 12.2849 18.8201 11.6952 18.8938 11.1056L21.3263 1.42519C21.3508 1.35149 21.3508 1.2778 21.3508 1.17942C21.3508 0.516003 20.8347 0.00013155 20.1223 0.00013155H7.91125C7.37073 0.00013155 6.92856 0.442295 6.92856 0.982824C6.92856 1.52335 7.37073 1.96552 7.91125 1.96552H19.1887L18.8202 3.43977H8.59927C8.05874 3.43977 7.61658 3.88194 7.61658 4.42247C7.61658 4.963 8.05874 5.40516 8.59927 5.40516H18.3042L17.9356 6.87955H9.1397C8.59917 6.87955 8.15701 7.32171 8.15701 7.86224C8.15701 8.40277 8.59917 8.84493 9.1397 8.84493H17.4442L17.0757 10.3192H7.54275L5.87211 0.810794C5.79842 0.343929 5.38077 0 4.9139 0H0.982693C0.442163 0 0 0.442163 0 0.982692C0 1.52322 0.442163 1.96556 0.982693 1.96556L0.982759 1.96567Z" fill="white" />
                                                <path d="M16.0444 18.4272C17.4449 18.4272 18.575 17.2725 18.575 15.8474C18.575 14.5207 17.6168 13.4396 16.3639 13.2923H16.3393H16.2656H16.1428H8.59993H8.55074H8.45253C7.05198 13.2923 5.92188 14.447 5.92188 15.8721C5.9217 17.297 7.05198 18.4272 8.42783 18.4272C9.80368 18.4272 10.9585 17.2725 10.9585 15.8474C10.9585 15.6263 10.934 15.4297 10.8848 15.2332H13.612C13.5628 15.4297 13.5383 15.6263 13.5383 15.8474C13.5383 17.2724 14.6686 18.4272 16.0445 18.4272H16.0444ZM16.0444 15.2332C16.3391 15.2332 16.6094 15.5034 16.6094 15.8474C16.6094 16.1914 16.3636 16.4616 16.0444 16.4616C15.7249 16.4616 15.4793 16.1914 15.4793 15.8474C15.4791 15.5034 15.7494 15.2332 16.0444 15.2332ZM8.42781 16.4616C8.13303 16.4616 7.86276 16.1914 7.86276 15.8474C7.86276 15.5034 8.10852 15.2332 8.42781 15.2332C8.74727 15.2332 8.99287 15.5034 8.99287 15.8474C8.99287 16.1914 8.74727 16.4616 8.42781 16.4616Z" fill="white" />
                                            </svg>
                                            Add to Cart
                                        </button>
                                    ) : (
                                        <button disabled>Adding...</button>
                                    )}
                                </div>

                                {/* <div className="Finance">
                                    <button onClick={() => navigate("/financing")}>
                                        Click to Finance
                                    </button>
                                </div> */}
                            </>
                        )}
                    </div>

                    <div>
                        {stockMessage && (
                            <p
                                style={{
                                    color: "#e81c2e",
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    marginTop: "8px",
                                }}
                            >
                                {stockMessage}
                            </p>
                        )}
                    </div>

                    {/* Help Section */}
                    <div className="product-help-box">
                        <div className="help-icon">
                            <i className="fa fa-phone"></i>
                        </div>

                        <div className="help-text">
                            Need help or have questions on this product?
                            <span>
                                {" "}Call our Fitment Specialists at{" "}
                                <a href="tel:4808929433">480.892.9433</a>
                            </span>
                        </div>
                    </div>


                </div>


                {(data?.category === "RC Wheels" || data?.category === "Wheels") && (
                    <>
                        <div className="mainAttributes">
                            <div className="row">
                                <div className="col-md-6 d-flex">
                                    <div className='iconImage'>
                                        <img src='/icons/wheel-diameter.svg' alt='img' height="100%" width="100%" />
                                    </div>
                                    <div className='d-grid'>
                                        <span><strong>Wheel Diameter</strong></span>
                                        <span className='px-4 mt-1'>
                                            {data.title.split(" | ")[3]?.split("x")[0]
                                                ? `${data.title.split(" | ")[3].split("x")[0]}"`
                                                : "N/A"}
                                        </span>
                                    </div>

                                </div>
                                <div className="col-md-6 d-flex">
                                    <div className='iconImage'>
                                        <img src='/icons/wheel-width.svg' alt='img' height="100%" width="100%" />
                                    </div>
                                    <div className='d-grid'>
                                        <span><strong>Wheel Width</strong></span>
                                        <span className='px-4 mt-1'>
                                            {data.title.split(" | ")[3]?.split("x")[1]
                                                ? `${data.title.split(" | ")[3].split("x")[1]}"`
                                                : "N/A"}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 d-flex">
                                    <div className="iconImage">
                                        <img src="/icons/wheel-offset.svg" alt="img" height="100%" width="100%" />
                                    </div>

                                    <div className="d-grid">
                                        <span><strong>Wheel Offset</strong></span>
                                        <span className="px-4 mt-1">
                                            {(() => {
                                                const lastWord = data.title.split(" ").pop();
                                                const match = lastWord?.match(/-?\d+(\.\d+)?(?=mm)/i);
                                                return match ? `${match[0]}` : "N/A";
                                            })()}
                                        </span>
                                    </div>

                                </div>
                                <div className="col-md-6 d-flex">
                                    <div className="iconImage">
                                        <img src="/icons/lug-pattern.svg" alt="img" height="100%" width="100%" />
                                    </div>
                                    <div className="d-grid">
                                        <span><strong>Lug Pattern</strong></span>
                                        <span className="px-4 mt-1">
                                            {data.title.split(" | ")[4] || "N/A"}
                                        </span>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="singleWheelSpecification">

                            <table className="table" style={{ fontSize: "14px" }}>
                                <tbody>
                                    <tr>
                                        <td style={{ borderLeft: "1px solid #ddd", width: "25%", paddingLeft: "10px" }}><strong>Brand</strong></td>
                                        <td style={{ borderRight: "1px solid #ddd", width: "25%" }}>
                                            {data.manufacturer || data.title.split(" ")[0] || "N/A"}
                                        </td>

                                        <td style={{ borderLeft: "1px solid #ddd", width: "25%", paddingLeft: "10px" }}><strong>Series / Model</strong></td>
                                        <td style={{ borderRight: "1px solid #ddd", width: "25%" }}>
                                            {data.title.split(" | ")[0]?.replace(data.manufacturer, "").trim() || "N/A"}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ borderLeft: "1px solid #ddd", paddingLeft: "10px" }}><strong>Construction Type</strong></td>
                                        <td style={{ borderRight: "1px solid #ddd" }}>
                                            {data.title.split(" | ")[1] || "N/A"}
                                        </td>

                                        <td style={{ borderLeft: "1px solid #ddd", paddingLeft: "10px" }}><strong>Finish</strong></td>
                                        <td style={{ borderRight: "1px solid #ddd" }}>
                                            {data.title.split(" | ")[2] || "N/A"}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ borderLeft: "1px solid #ddd", paddingLeft: "10px" }}><strong>Wheel Size</strong></td>
                                        <td style={{ borderRight: "1px solid #ddd" }}>
                                            {data.title.split(" | ")[3] || "N/A"}
                                        </td>

                                        <td style={{ borderLeft: "1px solid #ddd", paddingLeft: "10px" }}><strong>Wheel Diameter</strong></td>
                                        <td style={{ borderRight: "1px solid #ddd" }}>
                                            {data.title.split(" | ")[3]?.split("x")[0]
                                                ? `${data.title.split(" | ")[3].split("x")[0]}"`
                                                : "N/A"}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ borderLeft: "1px solid #ddd", paddingLeft: "10px" }}><strong>Wheel Width</strong></td>
                                        <td style={{ borderRight: "1px solid #ddd" }}>
                                            {data.title.split(" | ")[3]?.split("x")[1]
                                                ? `${data.title.split(" | ")[3].split("x")[1]}"`
                                                : "N/A"}
                                        </td>

                                        <td style={{ borderLeft: "1px solid #ddd", paddingLeft: "10px" }}><strong>Lug Pattern</strong></td>
                                        <td style={{ borderRight: "1px solid #ddd" }}>
                                            {data.title.split(" | ")[4] || "N/A"}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ borderLeft: "1px solid #ddd", paddingLeft: "10px" }}><strong>Wheel Offset</strong></td>
                                        <td style={{ borderRight: "1px solid #ddd" }}>
                                            {data.title.split(" | ")[5] || "N/A"}
                                        </td>

                                        <td style={{ borderLeft: "1px solid #ddd", paddingLeft: "10px" }}><strong>Shipping Weight</strong></td>
                                        <td style={{ borderRight: "1px solid #ddd" }}>
                                            {data.weight || "N/A"}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ borderLeft: "1px solid #ddd", paddingLeft: "10px" }}><strong>Height</strong></td>
                                        <td style={{ borderRight: "1px solid #ddd" }}>
                                            {data.height || "N/A"}
                                        </td>

                                        <td style={{ borderLeft: "1px solid #ddd", paddingLeft: "10px" }}><strong>Length</strong></td>
                                        <td style={{ borderRight: "1px solid #ddd" }}>
                                            {data.length || "N/A"}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ borderLeft: "1px solid #ddd", paddingLeft: "10px" }}><strong>Width</strong></td>
                                        <td style={{ borderRight: "1px solid #ddd" }}>
                                            {data.width || "N/A"}
                                        </td>

                                        <td style={{ borderLeft: "1px solid #ddd", paddingLeft: "10px" }}><strong>Shipping Group</strong></td>
                                        <td style={{ borderRight: "1px solid #ddd" }}>
                                            {data.shipping_group || "N/A"}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
            </div>



            <Modal show={showModal} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Your Enquiry About : {productName}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit} className='enquiry-form-class'>
                        <div className='row'>
                            <div className='col-md-6'>
                                <Form.Group controlId="email">
                                    <Form.Label>First Name*</Form.Label>
                                    <Form.Control
                                        type="firstName"
                                        placeholder="Enter first name"
                                        value={firstName}
                                        onChange={handleFirstNameChange}
                                        required
                                    />
                                </Form.Group>
                            </div>
                            <div className='col-md-6'>
                                <Form.Group controlId="lastName">
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control
                                        type="tel"
                                        placeholder="Enter last name"
                                        value={lastName}
                                        onChange={handleLastNameChange}
                                    />
                                </Form.Group>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-6'>
                                <Form.Group controlId="email">
                                    <Form.Label>Email*</Form.Label>
                                    <Form.Control
                                        type="email"
                                        placeholder="Enter email"
                                        value={email}
                                        onChange={handleEmailChange}
                                        required
                                    />
                                </Form.Group>
                            </div>
                            <div className='col-md-6'>
                                <Form.Group controlId="phone">
                                    <Form.Label>Phone Number</Form.Label>
                                    <Form.Control
                                        type="tel"
                                        placeholder="Enter phone number"
                                        value={phone}
                                        onChange={handlePhoneChange}
                                    />
                                </Form.Group>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12'>
                                <Form.Group controlId="comments">
                                    <Form.Label>Comments*</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        placeholder="Enter your comments"
                                        value={comments}
                                        onChange={handleCommentsChange}
                                        required
                                    />
                                </Form.Group>
                            </div>

                        </div>
                        <div className='row'>
                            <div className='col-md-12 text-end'>
                                <Form.Group controlId="comments">
                                    <Button variant="danger" type="submit">
                                        Submit
                                    </Button>
                                </Form.Group>
                            </div>
                        </div>

                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
}


